// extracted by mini-css-extract-plugin
export default {"root":"Bubble_root__bEt2I","info":"Bubble_info__wFpLm"};